import {
  CREATE_APPLIANCE,
  DELETE_APPLIANCE,
  GET_APLIANCE_DELETE,
  GET_APPLIANCES,
  GET_APPLIANCE_BY_ID,
  UPDATE_APPLIANCE,
} from '../types';

const initialState = {
  appliances: [],
  applianceById: {},
  applianceDelete: null,
};

export default function Appliances(state = initialState, action) {
  switch (action.type) {
    case CREATE_APPLIANCE:
      return {
        ...state,
        appliances: [...state.appliances, action.payload],
      };
    case GET_APPLIANCES:
      return {
        ...state,
        appliances: action.payload,
      };
    case GET_APPLIANCE_BY_ID:
      return {
        ...state,
        applianceById: action.payload,
      };
    case UPDATE_APPLIANCE:
      return {
        ...state,
        appliances: state.appliances.map((apl) =>
          apl.id === action.payload.id ? (apl = action.payload) : apl
        ),
      };
    case GET_APLIANCE_DELETE:
      return {
        ...state,
        applianceDelete: action.payload,
      };

    case DELETE_APPLIANCE:
      return {
        ...state,
        appliances: state.appliances.filter(
          (apl) => apl.id !== state.applianceDelete
        ),
      };

    default:
      return state;
  }
}
